module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BqlHyW/tc-custom/9781459202139.jpg?1725275569816",
      "alt": "This image is the cover for the book Gamekeeper's Lady, Rakes in Disgrace"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gamekeeper's Lady, Rakes in Disgrace\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Frederica Bracewell grew up under a cloud of shame. As an illegitimate child, she was treated by her uncle like a servant. It wasn't until she encountered the new gamekeeper that shy, innocent Frederica started to feel like a true lady."), _c('br'), _c('br'), _vm._v("Lord Robert Mountford had been banished by his family. After a debauched existence, he reveled in the simplicity of a gamekeeper's lifestyle. Until temptation struck! Frederica's plain appearance and stuttering speech were a far cry from the ladies of the "), _c('i', [_vm._v("ton,")]), _vm._v(" but she might just be his undoingand unmasking!"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Lethbridge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ann Lethbridge majored in history and business. She always loved the glamorous, if rather risky, Georgians and in particular the Regency era as drawn by Georgette Heyer. It was that love that prompted her to write her first Regency novel in 2000. She found she enjoyed it so much she just couldn’t stop! Ann gave up a career in university administration to focus on her first love, writing novels and lives in Canada with her family. Visit her website at: www.annlethbridge.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0